export const iconFontAwesomeCampingFaucet = (
	<i className="fa-solid fa-faucet"></i>
);
